module.exports = __webpack_public_path__ + "img/noun_Cat_564414.de0bb2fc.svg";